module.exports = __webpack_public_path__ + "static/media/sanduiche.ecd8044e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/sanduiche.svg
// module id = 2487
// module chunks = 0